<template>
  <div class="wineLabelItemComponentForm">
    <div
      data-v-fae5bece
      class="v-card__title headline lighten-2 v-card__title--primary"
    >
      Etikete
    </div>

    <v-form ref="form" v-model="valid" lazy-validation>
      <!--<v-layout row wrap>-->
      <!--<v-flex xs8>-->
      <!--<v-text-field-->
      <!--v-model="ID"-->
      <!--label="ID" readonly-->
      <!--&gt;</v-text-field>-->
      <!--</v-flex>-->
      <!--</v-layout> &lt;!&ndash; /.ID &ndash;&gt;-->

      <v-layout row wrap>
        <v-flex xs6 pa-2>
          <v-text-field
            v-model="naziv"
            label="Naziv"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>

        <v-flex xs3 pa-2>
          <v-autocomplete
            v-model="select"
            :items="wt_items"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="Tip vina"
            required
            persistent-hint
            return-object
          ></v-autocomplete>
        </v-flex>

        <v-flex xs3 pa-2>
          <v-text-field v-model="barkod" label="Bar kod"></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-checkbox
            v-model="samo_proizvodnja"
            label="Samo u proizvodnji"
            v-on:change="changeInProduction"
          ></v-checkbox>
        </v-flex>

        <v-flex xs2 pa-2>
          <v-text-field
            v-if="!samo_proizvodnja"
            v-model="zapremina_boce"
            label="Zapremina boce (l)"
            type="number"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            persistent-hint
            return-object
          ></v-text-field>
        </v-flex>

        <v-flex xs2 pa-2>
          <v-text-field
            v-model="service_temperature"
            label="Temperatura za posluživanje (°C)"
            type="number"
            persistent-hint
            return-object
          ></v-text-field>
        </v-flex>
        <v-flex xs6 pa-2>
          <v-text-field
            v-model="food_pairing"
            label="Hrana"
            persistent-hint
            return-object
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs10 pa-2>
          <v-text-field v-model="opis" name="input-5-1" class="Description" label="Opis"></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="pozicija"
            label="Redosled na prikazu"
            type="number"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn @click="clear" class="AppButtonOutlined">odustani</v-btn>
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "WineLabelItem",
  components: {
    TokenComponent,
  },
  data: () => ({
    valid: true,
    ID: "0",
    naziv: "",
    wt_items: [],
    select: "",
    opis: "",
    barkod: "",
    zapremina_boce: undefined,
    service_temperature: undefined,
    food_pairing: undefined,
    pozicija: undefined,
    samo_proizvodnja: false,
  }),

  methods: {
    isNumber(e) {
      e = e || window.event;
      var charCode = typeof e.which == "undefined" ? e.keyCode : e.which;
      var charStr = String.fromCharCode(charCode);

      

      if (!charStr.match(/^[0-9]+$/)) e.preventDefault();
      return true;
    },
    changeInProduction(e) {
      if (e) this.zapremina_boce = undefined;
    },
    newSifarnik() {
      var complexObjectWineType = {
        id: this.select.id,
      };

      if (this.samo_proizvodnja)
        var complexObject = {
          name: this.naziv,
          wineType: complexObjectWineType,
          ean: this.barkod,
          description: this.opis,
          inProduction: 1,
          serviceTemperature: this.service_temperature,
          foodPairing: this.food_pairing,
          position: this.pozicija,
        };
      else
        var complexObject = {
          name: this.naziv,
          wineType: complexObjectWineType,
          ean: this.barkod,
          description: this.opis,
          bottleVolumeInLiters: this.zapremina_boce,
          serviceTemperature: this.service_temperature,
          foodPairing: this.food_pairing,
          position: this.pozicija,
          inProduction: 0,
        };

      //// // console.log(complexObject);

      this.$http
        .post(
          this.globalServiceLocation + this.globalPort + "/wine_label/create",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.clear();

          serverBus.$emit("refresh_wine_label");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_label/create",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.clear();

                      serverBus.$emit("refresh_wine_label");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      var complexObjectWineType = {
        id: this.select.id,
      };

      var complexObject = {
        id: this.ID,
        name: this.naziv,
        wineType: complexObjectWineType,
        ean: this.barkod,
        description: this.opis,
        bottleVolumeInLiters: this.zapremina_boce,
        serviceTemperature: this.service_temperature,
        foodPairing: this.food_pairing,
        position: this.pozicija,
      };

      if (this.samo_proizvodnja)
        var complexObject = {
          id: this.ID,
          name: this.naziv,
          wineType: complexObjectWineType,
          ean: this.barkod,
          description: this.opis,
          inProduction: 1,
          serviceTemperature: this.service_temperature,
          foodPairing: this.food_pairing,
          position: this.pozicija,
        };
      else
        var complexObject = {
          id: this.ID,
          name: this.naziv,
          wineType: complexObjectWineType,
          ean: this.barkod,
          description: this.opis,
          bottleVolumeInLiters: this.zapremina_boce,
          serviceTemperature: this.service_temperature,
          foodPairing: this.food_pairing,
          position: this.pozicija,
          inProduction: 0,
        };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/wine_label/update/" +
            this.ID,
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.clear();

          serverBus.$emit("refresh_wine_label");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_label/update/" +
                        this.ID,
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.clear();

                      serverBus.$emit("refresh_wine_label");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllTipoveVina() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_type/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          //// // console.log(response.data);

          this.wt_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_type/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      //// // console.log(response.data);

                      this.wt_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.ID != "" && this.ID != "0") {
          this.changeSifarnik();
        } else {
          this.newSifarnik();
        }
      }
    },
    clear() {
      this.$refs.form.reset();
      this.ID = 0;
    },
  },
  mounted() {
    this.clear();

    this.getAllTipoveVina();

    serverBus.$on("applied_wine_label", (item) => {
      //alert(item.name);
      this.ID = item.id;
      this.naziv = item.name;
      this.opis = item.description;
      this.barkod = item.ean;

      this.samo_proizvodnja = item.inProduction;

      this.zapremina_boce = item.bottleVolumeInLiters;
      this.service_temperature = item.serviceTemperature;
      this.food_pairing = item.foodPairing;
      this.pozicija = item.position;

      if (item.wineType !== null) {
        this.select = item.wineType;
      } else {
        this.select = "";
      }
    });
  },
};
</script>
    
<style lang="scss" scoped>
// .wineLabelItemComponentForm {
//   max-width: 430px;
// }
.Description textarea {
  height: 40px;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
</style>
